export enum ETableLinkAppearance {
  CHEVRON = 'chevron',
  UNDERLINE = 'underline',
}
